import {createFileRoute} from "@tanstack/react-router";
import {AdminDocsIndexPage} from "~/components/adminDocs/adminDocsIndexPage";
import {ErrorComponent} from "../-errorComponent";
import {NotFoundComponent} from "../-notFoundComponent";
import {PendingComponent} from "../-pendingComponent";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/a/_adminScaffold/docs/")({
    component: AdminDocsIndexPage,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
